import { render, staticRenderFns } from "./location-restriction-extender.vue?vue&type=template&id=7e630f0d"
import script from "./location-restriction-extender.vue?vue&type=script&lang=js"
export * from "./location-restriction-extender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports